import { MinimalProduct } from "../types/product";

// Material rows only need the id to find the data sheet: a web material's product UUID, or a
// SevDesk material's SevDesk id (MaterialListItem hashes that one into the product UUID).

// GET jobs/{jobId}/monitor/{monitorId}/grouped-materials. Web materials come back as
// { productId, product, usedQuantity }, SevDesk ones already as { id, name, quantity }.
export const fromMonitorMaterials = (data: any): MinimalProduct[] =>
  [
    ...(data?.webProducts ?? []).map((p: any) => ({
      id: p.productId,
      name: p.product?.name ?? "",
      description: p.product?.description ?? null,
      quantity: p.usedQuantity ?? 0,
      payExtraQuantity: p.payExtraQuantity ?? 0,
    })),
    ...(data?.sevdeskProducts ?? []),
  ].filter((p: MinimalProduct) => p.id != null);

// GET jobs/{jobId}/materials, narrowed to the materials of one monitor event.
export const fromEventMaterials = (
  items: any[],
  monitorEventId: string
): MinimalProduct[] =>
  items
    .filter((item) => item.monitorEventId === monitorEventId)
    .map((item) => ({
      id: item.source === "sevdesk" ? item.sevdeskProductId : item.productId,
      name: item.product?.name ?? item.name ?? "",
      description: item.product?.description ?? item.description ?? null,
      quantity: item.quantity ?? 0,
      payExtraQuantity: item.payExtraQuantity ?? 0,
    }))
    .filter((p) => p.id != null);
